var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer",
    transform: "matrix(1 0 0 1 0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1H9L7 5V9H3V5Z",
    fill: "#231E1E",
    transform: "matrix(1 0 0 1 0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 1H8L6 5V9H4V5Z",
    fill: "#009A7E",
    transform: "matrix(1 0 0 1 0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarReportIcon);
export default __webpack_public_path__ + "static/media/SideBarReportIcon.18b39ba136c3a631cc7d53f016eab1af.svg";
export { ForwardRef as ReactComponent };